module.exports = __webpack_public_path__ + "img/icon-business-deal-cash.036ead4b.svg";